import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WIDGETS_FEATURE_KEY, WidgetsState } from '../widgets.state';

export const selectWidgetsFeature = createFeatureSelector<WidgetsState>(WIDGETS_FEATURE_KEY);

export const selectWidgetsForm = createSelector(selectWidgetsFeature, (state) => state.form);
export const selectWidgetsFormRevision = createSelector(selectWidgetsFeature, (state) => state.revision);
